<template>
    <div class="head_wrap">
        <div class="head">
            <div class="head_con">
                <ul class="menu_list">
                    <router-link to="/" exact>
                        <li class>
                            <a href="javascript:;">
                                <i class="c_line"></i>首页
                            </a>
                        </li>
                    </router-link>
                    <!-- <li @mouseenter="changeShow" @mouseleave="changeShow">
                        <a href="javascript:;">粘土</a>
                        <transition name="show">
                            <ul class="li_ul show" v-show="isshow">
                                <li class="gamelist">塔防三国志</li>
                                <li class="gamelist">王牌制片人</li>
                            </ul>
                        </transition>
                    </li> -->
                    <router-link to="/clay">
                        <li class>
                            <a href="javascript:;">
                                <i class="c_line"></i>
                                粘土
                            </a>
                            <!-- <transition name="show">
                                <ul class="li_ul show" v-show="isshow">
                                    <li class="gamelist">塔防三国志</li>
                                    <li class="gamelist">王牌制片人</li>
                                </ul>
                            </transition> -->
                        </li>
                    </router-link>
                    <router-link to="/figma">
                        <li class>
                            <a href="javascript:;">
                                <i class="c_line"></i>Figma
                            </a>
                        </li>
                    </router-link>
                    <router-link to="/voucher">
                        <li class>
                            <a href="javascript:;">
                                <i class="c_line"></i>Mycard點卡
                            </a>
                        </li>
                    </router-link>
                    <router-link to="/login">
                        <li class>
                            <a href="javascript:;">
                                <i class="c_line"></i>登入/註冊
                            </a>
                        </li>
                    </router-link>
                </ul>
                <!-- <router-link to="/login">
                    <div class="login">登入/註冊</div>
                </router-link> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isshow: false,
        }
    },
    mounted: function () {},
    methods: {
        changeShow: function () {
            this.isshow = true
        },
        leveaShow: function () {
            this.isshow = false
        },
    },
}
</script>
<style >
.show-enter-active,
.show-leave-active {
    transition: all 0.3s;
}
.show-enter,
.show-leave-to {
    height: 0px;
}
.show-enter-to,
.show-leave {
    height: 80px;
}
.li_ul {
    padding: 0;
    width: 124px;
    overflow: hidden;
    margin-top: 78px;
    text-align: center;
    background-color: #fff;
}
.menu_list .li_ul li {
    width: 124px;
    text-align: center;
    line-height: 40px;
}
.login {
    position: absolute;
    top: 0;
    right: 10px;
    color: #888;
}
.head_wrap {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 110;
    height: 90px;
    background: rgba(255, 255, 255, 0.8);
}
.head_con {
    width: 1200px;
    margin: 0 auto;
    position: relative;
}
.head_con .logo {
    display: block;
    overflow: hidden;
    position: absolute;
    left: 15px;
    top: 20px;
    font-size: 30px;
    color: #ff5f31;
}
.menu_list {
    display: block;
    width: auto;
    list-style: none;
    height: 80px;
    position: absolute;
    right: 0;
    top: 10px;
    margin: 0;
}
.menu_list li {
    width: 124px;
    display: block;
    float: left;
}
.menu_list li a {
    width: auto;
    display: block;
    float: left;
    height: 80px;
    padding: 0 19px;
    line-height: 100px;
    color: #333;
    text-decoration: none;
    font-size: 16px;
    position: relative;
    text-align: center;
    -webkit-transition: font-weight 0.3s;
    transition: font-weight 0.3s;
}
.menu_list a.active a .c_line,
.menu_list li:hover a .c_line {
    display: block;
}
.menu_list li a .c_line {
    display: none;
    height: 2px;
    width: 40px;
    background: #f08200;
    overflow: hidden;
    position: absolute;
    left: 50%;
    margin-left: -20px;
    bottom: 0;
    -webkit-transition: bottom 0.2s;
    transition: bottom 0.2s;
}
.menu_list li a .s_line {
    display: block;
    height: 13px;
    width: 1px;
    background: #fff;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -6.5px;
    opacity: 0.3;
    filter: alpha(opacity=30);
}
.menu_list .language_1 a.current {
    opacity: 1;
    filter: alpha(opacity=100);
}
.menu_list .language_1 a:hover {
    font-weight: 400;
    opacity: 1;
    filter: alpha(opacity=100);
}
.menu_list .language_1 .simple {
    margin-left: 20px;
}
.menu_list .language_1 a {
    height: 20px;
    width: auto;
    font-size: 14px;
    line-height: 20px;
    margin-top: 40px;
    padding: 0 8px;
    opacity: 0.6;
    filter: alpha(opacity=60);
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue